import $ from 'jquery';
import { h, render } from 'preact';
import { useMemo, useState } from 'preact/hooks';
import styled from 'styled-components';

import { buildMediaQuery, breakpoints } from '../../utils/media-queries';

import FilterBar from './FilterBar.jsx';
import Subscription from './Subscription.jsx';

const SuperCollection = ({ settings, ...props }) => {
    const [selectedFilter, setSelectedFilter] = useState('all-ages');

    const subscriptions = useMemo(() => {
        const filter = settings?.age_ranges.find(
            (r) => r.id === selectedFilter,
        );
        const subs = [];

        (filter?.order || []).forEach((id) => {
            const s = (settings?.subscriptions || []).find(
                (sub) => sub.id === id,
            );
            subs.push(s);
        });

        return subs;
    }, [settings?.subscriptions, selectedFilter]);

    return (
        <Container {...props}>
            <div className="-wrap -wrap--narrow">
                <Header>
                    {settings?.title?.length > 0 && (
                        <Title level={settings?.title_level}>
                            {settings?.title}
                        </Title>
                    )}
                    {settings?.subtitle?.length > 0 && (
                        <Subtitle>{settings?.subtitle}</Subtitle>
                    )}

                    <StyledFilterBar
                        options={settings?.age_ranges}
                        selected={selectedFilter}
                        onChange={setSelectedFilter}
                    />
                </Header>

                <Subscriptions>
                    {subscriptions.map((sub, i) => (
                        <Subscription
                            key={sub.id}
                            buttonText={settings?.view_more_button}
                            alternate={!!(i % 2)}
                            {...sub}
                        />
                    ))}
                </Subscriptions>
            </div>
        </Container>
    );
};

const Container = styled.div.attrs({
    className: '-padded',
})`
    background-color: #fff;
    padding-top: 64px;
    padding-bottom: 64px;

    @media ${buildMediaQuery(breakpoints.lg)} {
        padding-top: 80px;
        padding-bottom: 80px;
    }
`;

const Header = styled.header`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
    margin-bottom: 20px;
`;

const Title = styled.h2.attrs((p) => ({
    as: p.title_level || 'h2',
    className: '-h2',
}))`
    margin: 0;
`;

const Subtitle = styled.p`
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    margin: 0;

    @media ${buildMediaQuery(breakpoints.lg)} {
        font-size: 20px;
        line-height: 28px;
    }
`;

const StyledFilterBar = styled(FilterBar)`
    margin-top: 20px;
`;

const Subscriptions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    margin-top: 80px;
`;

export default ($el) => {
    $el.each(function () {
        const config = JSON.parse(
            $(this)[0].getElementsByTagName('script')[0].innerHTML,
        );
        render(<SuperCollection settings={config} />, $(this)[0]);
    });
};
